export const modulesConfig = {
  fr: {
    zoho: {
      mcp: true,
    },
    customer: {
      siret: true,
      apeCode: true,
      activity: true,
      bacVoucher: true,
      referral: true,
      taxId: false,
    },
    address: {
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: true,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: true,
    },
  },
  it: {
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: false,
      taxId: true,
    },
    address: {
      floor: false,
      apartmentNumber: false,
      province: true,
      isResident: true,
      energyLandscape: false,
    },
    commonData: {
      comparatorId: 2,
    },
    consumption: {
      showPriceDetails: false,
    },
  },
  be: {
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: false,
      taxId: false,
    },
    address: {
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: false,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: false,
    },
  },
  nl: {
    zoho: {
      mcp: false,
    },
    customer: {
      siret: true,
      apeCode: false,
      activity: false,
      bacVoucher: false,
      referral: false,
      taxId: false,
    },
    address: {
      floor: true,
      apartmentNumber: true,
      province: false,
      isResident: false,
      energyLandscape: false,
    },
    commonData: {
      comparatorId: null,
    },
    consumption: {
      showPriceDetails: false,
    },
  },
}
